/*
  Dabi Deri — listeleme sayfası davranışları.

  1) Filtre sütunu: sağ kenarda dar bir sütun. Üzerine gelince panel kısa
     bir gecikmeyle açılıyor, imleç çıkınca kapanıyor. Gecikmeler bölüm
     ayarından (data-rail-open / data-rail-close).
  2) Sıralama: yerel <select> yerinde duruyor ve form onunla çalışıyor;
     üstüne referans sitedeki gibi tasarımlı bir açılır menü kuruluyor.
  3) Filtre ya da sıralama değişince Craft bu alanı yeniden basıyor; bir
     gözlemci her seferinde kurulumu tekrarlıyor.

  Çekmece (sütunsuz) modda da ikonun üzerine gelince panel açılıyor.
*/

(() => {
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const root = document.documentElement;

  /* ---------- başlığın alt kenarı ---------- */

  let headerFrame = null;
  // Serit, listelemenin ustundeki sayfa basligi bandinin altindan baslar.
  // Bant ekranin ustune dogru kayinca serit menunun altina yaslanir.
  const measureRailTop = () => {
    const listing = document.querySelector('.dabi-listing--rail, .dabi-vitrin--rail');
    if (!listing) return;
    const headerBottom = parseFloat(getComputedStyle(root).getPropertyValue('--dabi-header-bottom')) || 0;
    let top = headerBottom;
    let el = listing.closest('.shopify-section')?.previousElementSibling;
    // Banner ile listeleme arasındaki akan kampanya şeridi de hesaba katılır; filtre şeridin altından başlar.
    let stripBottom = 0;
    while (el && !el.querySelector('.dabi-hero--layout-banner')) {
      const strip = el.querySelector('[data-dabi-ticker]:not([hidden])');
      if (strip) stripBottom = Math.max(stripBottom, Math.round(strip.getBoundingClientRect().bottom));
      el = el.previousElementSibling;
    }
    const banner = el?.querySelector('.dabi-hero--layout-banner');
    if (banner) top = Math.max(headerBottom, Math.round(banner.getBoundingClientRect().bottom));
    if (stripBottom) top = Math.max(headerBottom, stripBottom);
    root.style.setProperty('--dabi-rail-top', `${Math.max(0, top)}px`);
  };

  const measureHeader = () => {
    headerFrame = null;
    measureRailTop();
    // Ust menu kendi boyunu kendisi yaziyor (dabi-header); burasi yalnizca yedek.
    if (document.querySelector('.dabi-header[data-scroll-mode]')) return;
    const header = document.querySelector('.dabi-header-wrap .dabi-header') || document.querySelector('.dabi-header-wrap') || document.querySelector('.shopify-section-group-header-group');
    if (!header) return;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    root.style.setProperty('--dabi-header-bottom', `${bottom}px`);
  };
  const queueHeader = () => {
    if (headerFrame !== null) return;
    headerFrame = window.requestAnimationFrame(measureHeader);
  };

  /* ---------- filtre paneli: üzerine gelince aç / çıkınca kapat ---------- */

  const setupDisclosure = (details) => {
    if (details.dataset.dabiHover === 'on') return;
    details.dataset.dabiHover = 'on';

    const summary = details.querySelector('summary');
    if (!summary) return;

    const host = details.closest('.dabi-listing');
    const railMode = !!details.closest('.dabi-listing--rail');
    const openDelay = Number(host?.dataset.railOpen ?? 220);
    const closeDelay = Number(host?.dataset.railClose ?? 450);

    let openTimer = null;
    let closeTimer = null;

    const clearTimers = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      openTimer = null;
      closeTimer = null;
    };

    // Sütun modunda tüm sütun (ve panel) duyarlı; çekmece modunda yalnızca ikon.
    const zone = railMode ? details : summary;

    zone.addEventListener('pointerenter', () => {
      window.clearTimeout(closeTimer);
      closeTimer = null;
      if (!fine.matches || details.hasAttribute('open')) return;
      openTimer = window.setTimeout(() => {
        // Craft'ın kendi akışı: açılma, odak ve kilit onun kodunda.
        if (!details.hasAttribute('open')) summary.click();
      }, openDelay);
    });

    zone.addEventListener('pointerleave', () => {
      window.clearTimeout(openTimer);
      openTimer = null;
      if (!railMode || !fine.matches || !details.hasAttribute('open')) return;
      closeTimer = window.setTimeout(() => {
        if (!details.hasAttribute('open')) return;
        // Fiyat alanına yazarken imleç kayarsa panel kapanmasın.
        const active = document.activeElement;
        if (active && details.contains(active) && active.matches('input')) return;
        summary.click();
      }, closeDelay);
    });

    summary.addEventListener('click', clearTimers);
  };

  /* ---------- sütun: ürün ızgarası görünmüyorsa çekil ---------- */

  let railObserver = null;
  const setupRailVisibility = () => {
    const grid = document.getElementById('ProductGridContainer');
    const details = document.querySelector('.dabi-listing--rail .mobile-facets__disclosure');
    if (!grid || !details || !('IntersectionObserver' in window)) return;
    if (railObserver) railObserver.disconnect();
    railObserver = new IntersectionObserver(
      (entries) => {
        const visible = entries.some((e) => e.isIntersecting);
        const current = document.querySelector('.dabi-listing--rail .mobile-facets__disclosure');
        if (current) current.classList.toggle('is-rail-hidden', !visible);
      },
      { rootMargin: '0px 0px -12% 0px' }
    );
    railObserver.observe(grid);
  };

  /* ---------- sıralama menüsü ---------- */

  const CHEVRON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 15l6-6 6 6"/></svg>';

  let sortCounter = 0;

  const enhanceSort = (select) => {
    if (select.id === 'SortBy-mobile' || select.closest('.mobile-facets')) return;
    const field = select.closest('.facet-filters__field');
    if (!field || field.querySelector('.dabi-sort')) return;

    field.classList.add('dabi-sort-host');
    const labelEl = field.querySelector(`label[for="${select.id}"]`) || field.querySelector('label');
    const labelText = (labelEl?.textContent || '').trim();
    const listId = `DabiSortList-${(sortCounter += 1)}`;

    const wrap = document.createElement('div');
    wrap.className = 'dabi-sort';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'dabi-sort__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', listId);

    const label = document.createElement('span');
    label.className = 'dabi-sort__label';
    label.textContent = labelText;

    const value = document.createElement('span');
    value.className = 'dabi-sort__value';

    const chev = document.createElement('span');
    chev.className = 'dabi-sort__chev';
    chev.innerHTML = CHEVRON;

    button.append(label, value, chev);

    const list = document.createElement('ul');
    list.className = 'dabi-sort__list';
    list.id = listId;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', labelText);
    list.tabIndex = -1;

    const options = Array.from(select.options).map((opt) => {
      const li = document.createElement('li');
      li.className = 'dabi-sort__option';
      li.setAttribute('role', 'option');
      li.dataset.value = opt.value;
      li.textContent = opt.text;
      list.appendChild(li);
      return li;
    });

    wrap.append(button, list);
    field.appendChild(wrap);

    let focusIndex = -1;

    const sync = () => {
      const selected = select.options[select.selectedIndex];
      value.textContent = selected ? selected.text : '';
      options.forEach((li) => li.setAttribute('aria-selected', li.dataset.value === select.value ? 'true' : 'false'));
    };

    const setFocus = (i) => {
      focusIndex = (i + options.length) % options.length;
      options.forEach((li, n) => li.classList.toggle('is-focused', n === focusIndex));
      options[focusIndex].scrollIntoView({ block: 'nearest' });
    };

    const open = () => {
      wrap.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      setFocus(Math.max(0, select.selectedIndex));
      document.addEventListener('pointerdown', outside, true);
    };

    const close = (refocus) => {
      wrap.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      options.forEach((li) => li.classList.remove('is-focused'));
      document.removeEventListener('pointerdown', outside, true);
      if (refocus) button.focus();
    };

    const outside = (event) => {
      if (!wrap.contains(event.target)) close(false);
    };

    const choose = (li) => {
      close(true);
      if (select.value === li.dataset.value) return;
      select.value = li.dataset.value;
      sync();
      // Craft'ın facet formu `input` olayını dinliyor.
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    button.addEventListener('click', () => (wrap.classList.contains('is-open') ? close(false) : open()));
    options.forEach((li, n) => {
      li.addEventListener('click', () => choose(li));
      li.addEventListener('pointerenter', () => setFocus(n));
    });

    wrap.addEventListener('keydown', (event) => {
      const isOpen = wrap.classList.contains('is-open');
      if (event.key === 'Escape' && isOpen) {
        event.preventDefault();
        close(true);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!isOpen) open();
        else setFocus(focusIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (!isOpen) open();
        else setFocus(focusIndex - 1);
      } else if ((event.key === 'Enter' || event.key === ' ') && isOpen && focusIndex >= 0) {
        event.preventDefault();
        choose(options[focusIndex]);
      }
    });

    select.addEventListener('change', sync);
    sync();
  };

  /* ---------- serit penceresi: gruplar akordeon ----------
     Craft'in cekmece kodu grup basligina tiklaninca kayan bir alt menu
     aciyor ve odagi icine kilitliyor. Serit modunda masaustunde bu tiklama
     once yakalanip grup yerinde acilip kapaniyor. */

  const desktop = window.matchMedia('(min-width: 990px)');
  document.addEventListener(
    'click',
    (event) => {
      // Serit modunda her ekranda: telefonda da kayan alt menu yerine akordeon.
      const summary = event.target.closest('.dabi-listing--rail .mobile-facets__details > summary');
      if (!summary) return;
      event.preventDefault();
      event.stopPropagation();
      const details = summary.parentElement;
      const open = !details.hasAttribute('open');
      details.toggleAttribute('open', open);
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    },
    true
  );

  /* ---------- kurulum ---------- */

  const setupAll = () => {
    measureHeader();
    document.querySelectorAll('.mobile-facets__disclosure').forEach(setupDisclosure);
    document.querySelectorAll('.dabi-listing--sort select[name="sort_by"]').forEach(enhanceSort);
    setupRailVisibility();
  };

  let pending = null;
  const queueSetup = () => {
    window.clearTimeout(pending);
    pending = window.setTimeout(setupAll, 60);
  };

  const start = () => {
    setupAll();
    window.addEventListener('resize', queueHeader, { passive: true });
    window.addEventListener('load', measureHeader);
    // Baslik ilk olculdugunde logo henuz yuklenmemis olabiliyor; boyu
    // degistikce (logo, duyuru seridi, yazi tipi) yeniden olculsun.
    const headerEl = document.querySelector('.dabi-header-wrap .dabi-header') || document.querySelector('.dabi-header-wrap');
    if (headerEl && 'ResizeObserver' in window) new ResizeObserver(measureHeader).observe(headerEl);
    window.addEventListener('scroll', queueHeader, { passive: true });
    document.addEventListener('dabi:header:measured', queueHeader);

    // Filtre/sıralama değişince Craft bu alanları yeniden basıyor.
    document.querySelectorAll('.dabi-listing').forEach((host) => {
      new MutationObserver(queueSetup).observe(host, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Tema duzenleyici bolumu yeniden basinca gozlemci olur; kurulum tekrarlanir.
  document.addEventListener('shopify:section:load', (event) => {
    setupAll();
    const host = event.target.querySelector('.dabi-listing');
    if (host) new MutationObserver(queueSetup).observe(host, { childList: true, subtree: true });
  });
})();
